import React from 'react';
import { Col, DatePicker, Radio, Row } from 'antd';
import dayjs from 'dayjs';

export type JobStatus = 'All' | 'Completed' | 'Canceled';
export const allJobStatus: JobStatus[] = ['All', 'Completed', 'Canceled'];

interface JobsFilterProps {
    dateRange: [dayjs.Dayjs, dayjs.Dayjs];
    setDateRange: React.Dispatch<React.SetStateAction<[dayjs.Dayjs, dayjs.Dayjs]>>;
    quickStatusFilter: JobStatus;
    setQuickStatusFilter: React.Dispatch<React.SetStateAction<JobStatus>>;
}

export const JobsFilter: React.FC<JobsFilterProps> = ({
    dateRange,
    setDateRange,
    quickStatusFilter,
    setQuickStatusFilter,
}) => {
    return (
        <div style={{ flex: '1 1 auto' }}>
            <Row gutter={[15, 15]} style={{ marginBottom: 15 }}>
                <Col style={{ marginBottom: 15 }}>
                    <Radio.Group
                        value={quickStatusFilter}
                        buttonStyle="solid"
                        onChange={(e) => setQuickStatusFilter(e.target.value)}
                    >
                        {allJobStatus.map((v) => (
                            <Radio.Button key={`quickStatusFilter-${v}`} value={v}>
                                {v}
                            </Radio.Button>
                        ))}
                    </Radio.Group>
                </Col>
                <Col>
                    <DatePicker.RangePicker
                        value={dateRange as any}
                        onChange={(dates) => {
                            if (dates) setDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs]);
                        }}
                    />
                </Col>
            </Row>
        </div>
    );
};
